import { useLanguage } from "@/context/LanguageContext";

const screens = {
  timer: {
    es: {
      label: "ROUND 3 / 5",
      time: "2:47",
      status: "TRABAJO",
      next: "Descanso — 1:00",
      progress: 56,
    },
    en: {
      label: "ROUND 3 / 5",
      time: "2:47",
      status: "WORK",
      next: "Rest — 1:00",
      progress: 56,
    },
  },
  presets: {
    es: {
      title: "MIS PRESETS",
      items: [
        { name: "Boxeo 12 Rounds", tag: "Boxeo", fav: true },
        { name: "MMA 5x5", tag: "MMA", fav: false },
        { name: "HIIT Tabata", tag: "HIIT", fav: true },
        { name: "Muay Thai Basico", tag: "Muay Thai", fav: false },
      ],
    },
    en: {
      title: "MY PRESETS",
      items: [
        { name: "Boxing 12 Rounds", tag: "Boxing", fav: true },
        { name: "MMA 5x5", tag: "MMA", fav: false },
        { name: "HIIT Tabata", tag: "HIIT", fav: true },
        { name: "Muay Thai Basic", tag: "Muay Thai", fav: false },
      ],
    },
  },
  builder: {
    es: {
      title: "SESSION BUILDER",
      blocks: [
        { type: "Warmup", dur: "3:00", color: "#eab308" },
        { type: "Round 1", dur: "5:00", color: "#b87b56" },
        { type: "Descanso", dur: "1:00", color: "#22c55e" },
        { type: "Round 2", dur: "5:00", color: "#b87b56" },
        { type: "Cooldown", dur: "2:00", color: "#3b82f6" },
      ],
    },
    en: {
      title: "SESSION BUILDER",
      blocks: [
        { type: "Warmup", dur: "3:00", color: "#eab308" },
        { type: "Round 1", dur: "5:00", color: "#b87b56" },
        { type: "Rest", dur: "1:00", color: "#22c55e" },
        { type: "Round 2", dur: "5:00", color: "#b87b56" },
        { type: "Cooldown", dur: "2:00", color: "#3b82f6" },
      ],
    },
  },
};

function TimerScreen({ data }) {
  return (
    <div className="flex flex-col items-center justify-center h-full px-4">
      <div className="text-[10px] tracking-[0.3em] uppercase text-[#b87b56] mb-1">
        {data.label}
      </div>
      <div
        className="text-6xl font-bold text-white tracking-tight"
        style={{ fontFamily: "JetBrains Mono, monospace" }}
      >
        {data.time}
      </div>
      <div className="mt-2 px-3 py-1 bg-[#b87b56]/20 border border-[#b87b56]/30 text-[#b87b56] text-xs font-bold uppercase tracking-wider">
        {data.status}
      </div>
      {/* Progress bar */}
      <div className="w-full mt-6 h-1.5 bg-white/10 rounded-full overflow-hidden">
        <div
          className="h-full bg-[#b87b56] transition-all"
          style={{ width: `${data.progress}%` }}
        />
      </div>
      <div className="mt-3 text-[10px] text-slate-500 uppercase tracking-wider">
        {data.next}
      </div>
      {/* Controls */}
      <div className="flex items-center gap-6 mt-6">
        <div className="w-8 h-8 rounded-full border border-white/20 flex items-center justify-center">
          <div className="w-2.5 h-2.5 border-l-2 border-t-2 border-white/40 -rotate-45" />
        </div>
        <div className="w-12 h-12 rounded-full bg-[#b87b56] flex items-center justify-center">
          <div className="w-3 h-4 flex gap-1">
            <div className="w-1 h-full bg-white rounded-sm" />
            <div className="w-1 h-full bg-white rounded-sm" />
          </div>
        </div>
        <div className="w-8 h-8 rounded-full border border-white/20 flex items-center justify-center">
          <div className="w-2.5 h-2.5 border-r-2 border-t-2 border-white/40 rotate-45" />
        </div>
      </div>
    </div>
  );
}

function PresetsScreen({ data }) {
  return (
    <div className="flex flex-col h-full px-3 pt-2">
      <div
        className="text-sm font-bold text-white uppercase tracking-wider mb-3"
        style={{ fontFamily: "Oswald, sans-serif" }}
      >
        {data.title}
      </div>
      <div className="flex flex-col gap-2">
        {data.items.map((item, i) => (
          <div
            key={i}
            className="flex items-center justify-between bg-white/5 border border-white/5 px-3 py-2.5"
          >
            <div>
              <div className="text-xs font-medium text-white">{item.name}</div>
              <div className="text-[10px] text-slate-500 uppercase tracking-wider">
                {item.tag}
              </div>
            </div>
            {item.fav && (
              <div className="text-[#b87b56] text-xs">&#9733;</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function BuilderScreen({ data }) {
  return (
    <div className="flex flex-col h-full px-3 pt-2">
      <div
        className="text-sm font-bold text-white uppercase tracking-wider mb-3"
        style={{ fontFamily: "Oswald, sans-serif" }}
      >
        {data.title}
      </div>
      <div className="flex flex-col gap-1.5">
        {data.blocks.map((block, i) => (
          <div
            key={i}
            className="flex items-center gap-2.5 bg-white/5 border border-white/5 px-3 py-2"
          >
            <div
              className="w-1 h-6 rounded-full"
              style={{ backgroundColor: block.color }}
            />
            <div className="flex-1">
              <div className="text-xs font-medium text-white">{block.type}</div>
            </div>
            <div
              className="text-xs text-slate-400"
              style={{ fontFamily: "JetBrains Mono, monospace" }}
            >
              {block.dur}
            </div>
          </div>
        ))}
      </div>
      {/* Add block button */}
      <div className="mt-2 border border-dashed border-white/10 py-2 flex items-center justify-center">
        <span className="text-xs text-slate-500">+ Block</span>
      </div>
    </div>
  );
}

export default function PhoneMockup({ variant = "timer" }) {
  const { lang } = useLanguage();
  const data = screens[variant]?.[lang] || screens.timer[lang];

  return (
    <div
      data-testid={`phone-mockup-${variant}`}
      className="relative w-[220px] h-[440px] border-[6px] border-[#2a2f38] rounded-[2.5rem] bg-[#1a1f26] shadow-2xl shadow-black/60 overflow-hidden"
    >
      {/* Notch */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-5 bg-[#2a2f38] rounded-b-2xl z-10" />

      {/* Status bar */}
      <div className="h-8 flex items-end justify-between px-5 pb-0.5">
        <span
          className="text-[8px] text-slate-500"
          style={{ fontFamily: "JetBrains Mono, monospace" }}
        >
          9:41
        </span>
        <div className="flex items-center gap-1">
          <div className="w-3 h-1.5 border border-slate-500 rounded-[1px]">
            <div className="w-2 h-full bg-slate-500 rounded-[0.5px]" />
          </div>
        </div>
      </div>

      {/* Screen content */}
      <div className="h-[calc(100%-48px)]">
        {variant === "timer" && <TimerScreen data={data} />}
        {variant === "presets" && <PresetsScreen data={data} />}
        {variant === "builder" && <BuilderScreen data={data} />}
      </div>

      {/* Home indicator */}
      <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-20 h-1 bg-white/20 rounded-full" />
    </div>
  );
}
